export const filterFallbackMap = {
	qufu: {},
	zichan: {},
	chunbi: {},
	box: {
		1: '2格',
		2: '4格',
		3: '6格',
		4: '9格'
	},
	duanwei: {
		1: '黑鹰',
		2: '铂金',
		3: '钻石',
		4: '黄金',
		5: '白银',
		6: '青铜',
		7: '无段位',
		8: '三角洲巅峰'
	},
	level: {},
	login_type: {
		1: '扫码登录',
		2: '账号密码'
	},
	awm: {},
	is_ben: {
		1: '是',
		2: '否'
	},
	xunlian: {},
	bachang: {},
	daopi: {
		1: '信条',
		2: '赤霄',
		3: '怜悯',
		4: '影锋',
		5: '黑海',
		6: '北极星',
		7: '电锯惊魂',
		8: '龙牙',
		9: '暗星'
	},
	wuqi: {
		1: 'M7棱镜攻势',
		2: 'M4棱镜攻势',
		3: 'K416-命运',
		4: 'SCAR-电玩',
		5: '腾龙-气象感应',
		6: 'QBZ95-王牌之剑',
		7: 'Vctor-中锋枪-美杜莎',
		8: 'AS Val突击步枪-悬赏令',
		9: 'AUG-气象感应'
	},
	ganyuan: {
		1: '红狼 - 蚀金玫瑰',
		2: '红狼 - 黑鹰坠落',
		3: '威龙 - 蛟龙行动',
		4: '威龙 - 铁面判官',
		5: '威龙 - 吴彦祖',
		6: '蜂医 - 送葬人',
		7: '蜂医 - 黑鹰坠落',
		8: '蜂医 - 危险物质',
		9: '无名 - 夜鹰',
		10: '乌鲁售・黑鹰坠落',
		11: '牧羊人 - 黑鹰坠落',
		12: '牧羊人 - 街头之王',
		13: '露娜 - 黑 - 天际线',
		14: '蛊 - 能天使 - 午夜邮差',
		15: '骇爪 - 维什戴尔',
		16: '骇爪 - 水墨云图',
		17: '露娜 - 金牌射手',
		18: '深蓝 - 不破之誓',
		19: '红狼 - 电锯惊魂',
		20: '威龙 - 凌霄戍卫'
	},
	is_feng: {
		1: '无记录',
		2: '有记录'
	},
	changzhu: {
		1: '北京',
		2: '天津',
		3: '河北',
		4: '山西',
		5: '内蒙古',
		6: '辽宁',
		7: '吉林',
		8: '黑龙江',
		9: '上海',
		10: '江苏',
		11: '浙江',
		12: '安徽',
		13: '福建',
		14: '江西',
		15: '山东',
		16: '河南',
		17: '湖北',
		18: '湖南',
		19: '广东',
		20: '广西',
		21: '海南',
		22: '重庆',
		23: '四川',
		24: '贵州',
		25: '云南',
		26: '西藏',
		27: '陕西',
		28: '甘肃',
		29: '青海',
		30: '宁夏',
		31: '新疆',
		32: '台湾',
		33: '香港',
		34: '澳门'
	},
	leixing: {
		1: '纯币号',
		2: '纯币+物资'
	}
};

export function getFilterTitleByValue(fieldName, value, filterlist) {
	if (!value || value === '') {
		return '';
	}

	const fieldItem = filterlist && filterlist.find(item => item.name === fieldName);
	
	if (fieldItem && fieldItem.content) {
		const values = value.toString().split(',');
		const titles = [];
		
		for (const val of values) {
			const trimmedVal = val.trim();
			const contentItem = fieldItem.content.find(c => c.value == trimmedVal || c.value === trimmedVal);
			if (contentItem) {
				titles.push(contentItem.title);
			} else if (filterFallbackMap[fieldName]) {
				const fallbackTitle = filterFallbackMap[fieldName][trimmedVal];
				if (fallbackTitle) {
					titles.push(fallbackTitle);
				} else {
					titles.push(trimmedVal);
				}
			} else {
				titles.push(trimmedVal);
			}
		}
		
		return titles.join(',');
	}

	if (filterFallbackMap[fieldName]) {
		const values = value.toString().split(',');
		const titles = [];
		
		for (const val of values) {
			const trimmedVal = val.trim();
			const fallbackTitle = filterFallbackMap[fieldName][trimmedVal];
			if (fallbackTitle) {
				titles.push(fallbackTitle);
			} else {
				titles.push(trimmedVal);
			}
		}
		
		return titles.join(',');
	}

	return value.toString();
}

export function buildFilterFallbackData() {
	return JSON.parse(JSON.stringify(filterFallbackMap));
}
